import * as React from 'react';
export const phoneSvg = React.forwardRef(function phoneSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M10 1.5H6A1.5 1.5 0 0 0 4.5 3v10A1.5 1.5 0 0 0 6 14.5h4a1.5 1.5 0 0 0 1.5-1.5V3A1.5 1.5 0 0 0 10 1.5ZM6 0a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h4a3 3 0 0 0 3-3V3a3 3 0 0 0-3-3H6Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M5.5 12.5c0-.345.28-.625.625-.625h3.75a.625.625 0 1 1 0 1.25h-3.75A.625.625 0 0 1 5.5 12.5Z',
    }),
  );
});
phoneSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var phone = {
  category: 'icon',
  colorable: true,
  name: 'phone',
  svg: phoneSvg,
};
